var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { makeStyles, Paper } from "@material-ui/core";
import clsx from "clsx";
export default React.forwardRef((_a, ref) => {
    var { className, disableMargin } = _a, otherProps = __rest(_a, ["className", "disableMargin"]);
    const classes = useStyles({ disableMargin });
    return (React.createElement(Paper, Object.assign({ ref: ref, className: clsx(className, classes.root) }, otherProps)));
});
const useStyles = makeStyles((theme) => ({
    root: ({ disableMargin }) => ({
        overflow: "hidden",
        border: "0.5px solid #EBEDF0",
        backgroundColor: theme.palette.text.onColor,
        boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.04), 0px 4px 4px rgba(0, 0, 0, 0.08)",
        borderRadius: 4,
        margin: disableMargin ? 0 : "8px 0 !important",
    }),
}));
//# sourceMappingURL=FTLPaper.js.map